export const ResultViewType = Object.freeze({
    TOP: "TOP",
    SIDE: "SIDE",
});